import { Component, OnInit, Inject, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { IConfig } from '../../../../interfaces/config.interface';
import { NextComponentService } from '../../../../services/next-component.service';
import { IComponentDetails } from '../../../../interfaces/component-details.interface';
import { ComponentGroup } from '../../../../enum/component-group.enum';
import { StepComponent } from '../stepcomponent.class';
import { PersonalInfoComponent } from '../personal-info/personal-info.component';
import { ComponentName } from '../../../../enum/component-name.enum';
import { ResidenceInfoComponent } from '../residence-info/residence-info.component';
import { EmploymentInfoComponent } from '../employment-info/employment-info.component';
import { AdditionalInfoComponent } from '../additional-info/additional-info.component';
import { StepType } from '../../../../enum/step-type.enum';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { PreviousComponentService } from '../../../../services/previous-component.service';
import { CreditAppService } from '../../../../services/credit-app.service';
import { NotificationsService } from '../../../../../lib/services/notifications.service';
import { INotification, NotificationType } from '../../../../../lib/interfaces/notification.interface';
import { ConfirmationPageComponent } from '../confirmation-page/confirmation-page.component';
import {
  SubmitInitiated, LeadDataSubmit,
  FormSuccess, FormFailure, EditCTAClick, ServerError
} from '../../../../../lib/actions/analytics.action';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { IAnalyticsErrorResponse } from '../../../../../lib/interfaces/analytics.interface';
import { UDOConstant, ErrorType } from '../../../../../lib/enum/analytics.enum';
import { getBackButton } from '../../../../utils/utils.functions';
import { HeapIoService } from '../../../../services/heap-io.service';

@Component({
  selector: 'dt-review-info',
  templateUrl: './review-info.component.html',
  styleUrls: ['./review-info.component.scss'] ,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ReviewInfoComponent implements OnInit {
  @ViewChild('scrollDiv', { static: true }) scrollContainer: ElementRef;
  SCData: any;
  buyer: any;
  concentForm: UntypedFormGroup;
  intialMask = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/];
  namePattern = '^(?!\\s*$)[A-Za-z\\s\-\'\`\’\‘]*$';
  siteCoreData: any;
  residenceType: any;
  incomeFrequency: any;
  employmentStatus: any;
  employmentType: any;
  employmentTypeEnum: any;
  cobuyer: any;
  coBuyerExist = false;
  isSaving = false;
  isBuyNow = false;
  isIframe = false;
  showScrollDownCTA = true;
  SubPage = '';
  isLegacyCreditApp:boolean = false;
  constructor(@Inject('config') public config: IConfig,
              private creditService: CreditAppService,
              private nextComponentService: NextComponentService,
              private prevComponentService: PreviousComponentService,
              private fb: UntypedFormBuilder,
              private notificationService: NotificationsService,
              private analyticsEventService: AnalyticsEventService,
              private readonly heapIoService: HeapIoService
  ) { }

  ngOnInit() {
    if (this.config.Sitecore && this.config.Sitecore.CreditApplicationConfig) {
      this.isBuyNow = this.config.Sitecore.isBuyNow;
      this.isIframe = this.config.Sitecore.isIframe;
      this.SCData = this.config.Sitecore.CreditApplicationConfig;
      this.siteCoreData = this.config.Sitecore.CreditApplicationConfig.ReviewInformation;
      this.isLegacyCreditApp = this.config.Sitecore.isLegacyCreditApp;
      if(this.isLegacyCreditApp){
        this.updateCtas();
      }
      this.residenceType = this.config.Sitecore.LookupMappingInformation.filter(x => x.LookupName === 'ResidenceType')[0].Mappings;
      this.employmentStatus =
        this.config.Sitecore.LookupMappingInformation.filter(x => x.LookupName === 'EmploymentStatusType')[0].Mappings;
      this.employmentType =
        this.config.Sitecore.LookupMappingInformation.filter(x => x.LookupName === 'EmploymentType')[0].Mappings;
      this.employmentTypeEnum =
        this.config.Sitecore.LookupMappingInformation.filter(x => x.LookupName === 'EmploymentTypeEnum')[0].Mappings;
if(this.config.Sitecore.isLegacyCreditApp){
  this.coBuyerExist = !!this.creditService.LegacyCreditApplication.coBuyer;
}else{
  this.coBuyerExist = !!this.creditService.CreditApplication.coBuyer;
}
      
      this.setBuyerAndCoBuyerData();
      this.incomeFrequency =
        this.config.Sitecore.LookupMappingInformation.filter(x => x.LookupName === 'IncomePeriodIntervalType')[0].Mappings;
        this.SubPage = this.config.Sitecore.SubPage ? this.config.Sitecore.SubPage : '';

    }

    this.showScrollDownCTA = true;

    this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
      if (n !== null && n.Type === NotificationType.coBuyerActivation) {
        this.coBuyerExist = true;
      } else if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
        this.coBuyerExist = false;
        if(this.concentForm) {this.concentForm.markAsDirty();}
      } else if (n !== null && n.Type === NotificationType.reviewTriggered) {
        this.setBuyerAndCoBuyerData();
      }
    });

    if(this.isBuyNow){
      this.heapIoService.trackPageview('credit-application/review');
    }

  }

  scrollToBottom() {
    try {
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
      this.showScrollDownCTA = false;
      window.scrollTo(0, document.querySelector('.scrollDiv').scrollHeight);
    } catch (err) {
      console.error('there was issue with scrolling to bottom');
    }
  }
  setBuyerAndCoBuyerData() {
    this.showScrollDownCTA = true;
    if(this.config.Sitecore.isLegacyCreditApp){
      this.buyer = this.creditService.LegacyCreditApplication.buyer;
    this.cobuyer = this.coBuyerExist ? this.creditService.LegacyCreditApplication.coBuyer : null;
    }else{
      this.buyer = this.creditService.CreditApplication.buyer;
      this.cobuyer = this.coBuyerExist ? this.creditService.CreditApplication.coBuyer : null;
    }
    this.concentForm = this.coBuyerExist ? this.fb.group({
      Buyer: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(51), Validators.pattern(this.namePattern)]],
      Cobuyer: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(51), Validators.pattern(this.namePattern)]]
    }) : this.fb.group({
      Buyer: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(51), Validators.pattern(this.namePattern)]]
    });
  }
  getFlag(years) {
    const y = Number(years);
    return y < 2;
  }

  loadComponent($event, componentName) {
    $event.preventDefault();
    let nextComponent: IComponentDetails;
    switch (componentName) {
      case this.siteCoreData.PersonalInfo: {
        nextComponent = {
          groupName: ComponentGroup.PersonalInfo,
          component: new StepComponent(PersonalInfoComponent,
            ComponentName.PersonalInfoComponent, ComponentGroup.PersonalInfo, true),
          componentName: ComponentName.PersonalInfoComponent,
        };
        break;
      }
      case this.siteCoreData.ResideceInfo: {
        nextComponent = {
          groupName: ComponentGroup.ResidenceInfo,
          component: new StepComponent(ResidenceInfoComponent,
            ComponentName.ResidenceInfoComponent, ComponentGroup.ResidenceInfo, true),
          componentName: ComponentName.ResidenceInfoComponent,
        };
        break;
      }
      case this.siteCoreData.EmploymentInfo: {
        nextComponent = {
          groupName: ComponentGroup.EmploymentInfo,
          component: new StepComponent(EmploymentInfoComponent,
            ComponentName.EmploymentInfoComponent, ComponentGroup.EmploymentInfo, true),
          componentName: ComponentName.EmploymentInfoComponent,
        };
        break;
      }
      case this.siteCoreData.AdditionalIncome:
      case this.siteCoreData.AdditionalInfo: {
        nextComponent = {
          groupName: ComponentGroup.AdditionalInfo,
          component: new StepComponent(AdditionalInfoComponent,
            ComponentName.AdditionalInfoComponent, ComponentGroup.AdditionalInfo, true),
          componentName: ComponentName.AdditionalInfoComponent,
        };
        break;
      }
      case this.siteCoreData.Cobuyerpersonalinfo: {
        nextComponent = {
          groupName: ComponentGroup.CoBuyerPersonal,
          component: new StepComponent(PersonalInfoComponent,
            ComponentName.CoBuyerPersonalInfoComponent, ComponentGroup.CoBuyerPersonal, true, StepType.CoBuyer),
          componentName: ComponentName.CoBuyerPersonalInfoComponent,
        };
        break;
      }
      case this.siteCoreData.Cobuyerreisdenceinfo: {
        nextComponent = {
          groupName: ComponentGroup.CoBuyerResidence,
          component: new StepComponent(ResidenceInfoComponent,
            ComponentName.CoBuyerResidenceInfoComponent, ComponentGroup.CoBuyerResidence, true, StepType.CoBuyer),
          componentName: ComponentName.CoBuyerResidenceInfoComponent,
        };
        break;
      }
      case this.siteCoreData.Cobuyeremployment: {
        nextComponent = {
          groupName: ComponentGroup.CoBuyerEmployment,
          component: new StepComponent(EmploymentInfoComponent,
            ComponentName.CoBuyerEmploymentInfoComponent, ComponentGroup.CoBuyerEmployment, true, StepType.CoBuyer),
          componentName: ComponentName.CoBuyerEmploymentInfoComponent,
        };
        break;
      }
      case this.siteCoreData.Cobuyeradditionalincome: {
        nextComponent = {
          groupName: ComponentGroup.CoBuyerAdditional,
          component: new StepComponent(AdditionalInfoComponent,
            ComponentName.CoBuyerAdditionalInfoComponent, ComponentGroup.CoBuyerAdditional, true, StepType.CoBuyer),
          componentName: ComponentName.CoBuyerAdditionalInfoComponent,
        };
        break;
      }
    }

    this.analyticsEventService.reportAnalyticsEvent(
      new EditCTAClick(nextComponent.component)
    );
    this.nextComponentService.loadComponent(nextComponent);
  }

  goBack() {
    const currentComponent: IComponentDetails = {
      groupName: ComponentGroup.ReviewInfo,
      component: new StepComponent(ReviewInfoComponent,
        ComponentName.ReviewInfoComponent, ComponentGroup.ReviewInfo, true, StepType.General),
      componentName: ComponentName.ReviewInfoComponent
    };
    this.prevComponentService.loadComponent(currentComponent);
    if (this.coBuyerExist && this.isLegacyCreditApp) {
      this.notificationService.broadcastNotification({
        Message: 'Buyer has used Summoning Jutsu for Co-Buyer', Type: NotificationType.coBuyerActivation
      });
    }
  }

  goNext() {
    let ca:any;
    if (this.concentForm && this.concentForm.valid && this.concentForm.dirty && this.SCData && this.SCData.ReviewInformation) {
      if (this.config?.Sitecore?.isLegacyCreditApp) {
        ca = { ...this.creditService.LegacyCreditApplication };
      }else{
        ca = { ...this.creditService.CreditApplication };
      }
      ca.step = 13;
      ca.buyerAuthorizationConsent = true;
      ca.buyer.consentIndicator = true;
      ca.buyerFullName = this.concentForm.get('Buyer').value;
      ca.disclaimers.buyerAuthorization = this.SCData.ReviewInformation.Disclaimer;
      if (ca.hasCoBuyer  || ca.coBuyer !== undefined) {
        ca.disclaimers.buyerAuthorization = this.SCData.ReviewInformation.CoBuyerDisclaimer;
        ca.disclaimers.coBuyerAuthorization = this.SCData.ReviewInformation.CoBuyerDisclaimer;
        ca.coBuyerAuthorizationConsent = true;
        ca.buyerRegulationBConsent = true;
        ca.coBuyerRegulationBConsent = true;
        ca.coBuyer.consentIndicator = true;
        ca.coBuyerFullName = this.concentForm.get('Cobuyer').value;
      }

      getBackButton();
      this.analyticsEventService.reportAnalyticsEvent(
        new SubmitInitiated(new StepComponent(ReviewInfoComponent,
          ComponentName.ReviewInfoComponent,
          ComponentGroup.ReviewInfo, true, StepType.General))
      );

      this.isSaving = true;

      if (this.config?.Sitecore?.isLegacyCreditApp) {
        delete ca.creditApplicationStatus;
        delete ca.sameAddresAsApplicant;
        delete ca.coBuyerAuthorizationConsent;
        delete ca.buyerRegulationBConsent;
        delete ca.coBuyerRegulationBConsent;
        delete ca.hasCoBuyer;
        delete ca.buyerAuthorizationConsent;
        delete ca.shortForm.dealParameters.opptId;
        delete ca.shortForm.dealParameters.creditAppId;
      }
      // no waiting screen
      this.creditService.SaveCreditApp(ca,this.SubPage).subscribe(response => {
        if (response.isSuccess) {
          this.isSaving = false;
          this.analyticsEventService.reportAnalyticsEvent(
            new LeadDataSubmit(new StepComponent(ReviewInfoComponent,
              ComponentName.ReviewInfoComponent,
              ComponentGroup.ReviewInfo, true, StepType.General,
              ca))
          );

          // load success screen
          this.loadNextComponent();

          this.analyticsEventService.reportAnalyticsEvent(
            new FormSuccess(new StepComponent(ConfirmationPageComponent,
              ComponentName.ConfirmationPageComponent,
              ComponentGroup.ConfirmationPage, true, StepType.General,
              ca))
          );
        } else {
          this.isSaving = false;
          this.analyticsEventService.reportAnalyticsEvent(
            new FormFailure(new StepComponent(ReviewInfoComponent,
              ComponentName.ReviewInfoComponent,
              ComponentGroup.ReviewInfo, true, StepType.General,
              ca))
          );
        }
      }, error => {
        this.isSaving = false;
        this.reportErrorResponse(error);
      });

      /*this.loadNextComponent();
      const startTime = performance.now();
      this.creditService.SendInfoToBank(ca).subscribe(
        r => {
          console.log('Done BANK submition');
          this.notificationService.broadcastNotification({
            Message: 'Done BANK submition', Type: NotificationType.bankRequest, Payload: startTime
          });
        }
      );*/
    }
  }


  reportErrorResponse(errorData: any) {
    const analyticsErrorResponse: IAnalyticsErrorResponse = {
      error: errorData.statusCode ? errorData.statusCode : UDOConstant.ErrorCode,
      error_message: errorData.message ? errorData.message : UDOConstant.ServiceUnavailable,
      error_type: ErrorType.CreditAppNotSubmitted
    };
    this.analyticsEventService.reportAnalyticsEvent(
      new ServerError(new StepComponent(ReviewInfoComponent,
        ComponentName.ReviewInfoComponent,
        ComponentGroup.ReviewInfo, true, StepType.General),
        analyticsErrorResponse));
  }

  loadNextComponent() {
    let nextComponent: IComponentDetails;
    nextComponent = {
      groupName: ComponentGroup.ReviewInfo,
      component: new StepComponent(ConfirmationPageComponent,
        ComponentName.ConfirmationPageComponent, ComponentGroup.ReviewInfo, true),
      componentName: ComponentName.ConfirmationPageComponent,
    };
    this.nextComponentService.loadComponent(nextComponent);
  }

  getPhoneNumer(phone) {
    if (phone) {
      let p = phone.match(/\d/g);
      p = p.join('');
      return '(' + p.substr(0, 3) + ') ' + p.substr(3, 3) + '-' + p.substr(6, 4);
    }
    return '';
  }

  getResidenceType(value) {
    if (value) {
      const ans = this.residenceType.filter(x => x.Value === value.toString());
      return ans && ans[0] ? ans[0].Description : '';
    }
    return '';
  }

  getIncomeFrequency(value) {
    if (value !== undefined && value !== null) {
      const val = this.incomeFrequency.filter(x => x.Description === value);
      return val && val[0] ? val[0].Description : '';
    }
    return '';
  }

  getEmploymentStatus(value) {
    if (value !== undefined && value !== null) {
      const val = this.employmentStatus.filter(x => x.Value === value);
      return val && val[0] ? val[0].Description : '';
    }
    return '';
  }

  getEmploymentType(value) {
    if (value !== undefined && value !== null) {
      const val = this.employmentType.filter(x => x.Value === value);
      return val && val[0] ? val[0].Description : '';
    }
    return '';
  }

  updateCtas() {
    try {
      (window as any).standalonePrequal.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }

}
